export default {"src":"/_next/static/media/close_basic_icon_white.59c0beab.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};